import { useEffect, useState } from "react";
import axios from "axios";
import { FadeUp, SectionHeading } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Gallery = () => {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/photos`, { params: { category: "gallery" } }).then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  if (!photos.length) return null;

  return (
    <section id="gallery" className="px-6 md:px-12 py-28 md:py-40 bg-surface border-y border-white/10" data-testid="gallery-section">
      <SectionHeading index="Site Gallery" title="From The Field" testId="gallery-heading" />
      <div className={photos.length < 3 ? "grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl" : "columns-2 md:columns-3 gap-6"}>
        {photos.map((p, i) => (
          <FadeUp key={p.id} delay={(i % 3) * 0.08} className="mb-6 break-inside-avoid">
            <figure>
              <img
                src={`${API}/photos/file/${p.id}`}
                alt={p.title}
                loading="lazy"
                className="w-full border border-white/15 grayscale hover:grayscale-0 transition-all duration-700"
                data-testid={`gallery-photo-${p.id}`}
              />
              <figcaption className="mt-2 text-[10px] tracking-[0.25em] uppercase text-ash">{p.title}</figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};
